import PhotoDocumentReject from './PhotoDocumentReject';

export default PhotoDocumentReject;
